import { type FormAnswer } from '@pixacare/forms';
import { FileWithModuleId } from './file-with-module-id';

export const FORM_OUTPUTS_PICTURE_KEY = 'pictures';

export type FormOutputs = {
  [key in typeof FORM_OUTPUTS_PICTURE_KEY]?: FileWithModuleId[];
} & FormAnswer;
